import React, { useState } from 'react'
import {
    Box,
    Tab,
    Tabs,
    Typography,
    makeStyles,
    Theme,
} from '@material-ui/core'

import { EzosApplicantDataTemplateEditor } from './EzosApplicantDataTemplateEditor'

const APPLICANT_DATA = 0
const GUEST_CARD = 1
const APPLICATION_FEE = 2
const SIGNABLE_DOCS = 3

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        minHeight: 420,
        backgroundColor: theme.palette.background.paper,
    },
    intro: {
        padding: theme.spacing(1.25, 1.5, 0.5),
        fontSize: '0.8125rem',
        color: theme.palette.text.secondary,
        lineHeight: 1.45,
    },
    tabs: {
        minHeight: 40,
        borderBottom: `1px solid ${theme.palette.divider}`,
        '& .MuiTab-root': {
            minHeight: 40,
            textTransform: 'none',
            fontWeight: 600,
            fontSize: '0.8125rem',
        },
    },
    panel: {
        flex: 1,
        minHeight: 0,
        overflow: 'hidden',
    },
    placeholder: {
        padding: theme.spacing(4),
        textAlign: 'center',
        color: theme.palette.text.secondary,
        fontSize: '0.875rem',
    },
}))

/**
 * EZOS-level Leasing Season Config — mirrors property Setup artifacts.
 * Applicant Data is live (standard template); other artifacts are placeholders.
 */
export const LeasingSeasonConfigAdminTab: React.FC = () => {
    const classes = useStyles()
    const [tab, setTab] = useState(APPLICANT_DATA)

    return (
        <Box className={classes.root}>
            <Typography className={classes.intro}>
                Edit EZOS starter templates. Changes bump the template version
                and apply only to new adoptions — existing property copies are
                not updated.
            </Typography>
            <Tabs
                className={classes.tabs}
                value={tab}
                onChange={(_, next) => setTab(next)}
                indicatorColor="primary"
                textColor="primary"
            >
                <Tab label="Applicant Data" value={APPLICANT_DATA} />
                <Tab label="Guest Card" value={GUEST_CARD} />
                <Tab label="Application Fee" value={APPLICATION_FEE} />
                <Tab label="Signable Documents" value={SIGNABLE_DOCS} />
            </Tabs>
            <Box className={classes.panel}>
                {tab === APPLICANT_DATA ? (
                    <EzosApplicantDataTemplateEditor />
                ) : (
                    <Typography className={classes.placeholder}>
                        EZOS template editing for this artifact is coming soon.
                    </Typography>
                )}
            </Box>
        </Box>
    )
}
